import { IVoteOption } from "../models/ballot-vote";
import { materialSymbols } from "./material-symbols";

export enum SDBallotStatus {
  NotOpen = 'PBS_NOT_OPEN',
  Open = 'PBS_OPEN',
  Closed = 'PBS_CLOSED',
  Accepted = 'PBS_ACCEPTED'
}

export enum SdVoteId {
  VT_AGREE = "VT_AGREE",
  VT_DISAGREE = "VT_DISAGREE",
  VT_NONE = "VT_NONE"
}

export const sdVoteOption: { [key in SdVoteId]: IVoteOption } = {
  [SdVoteId.VT_AGREE]: {color: '#1A936F', icon: materialSymbols.checkCircle, text: 'Agree'},
  [SdVoteId.VT_DISAGREE]: {color: '#CE1114', icon: materialSymbols.cancel, text: 'Disagree'},
  [SdVoteId.VT_NONE]: {color: '#FFB500', icon: materialSymbols.doNotDisturb, text: 'No Response'}
}